module.exports = __webpack_public_path__ + "img/padlock.9488b978.svg";